export enum CookieConsentCompliance {
  HIDDEN = 'HIDDEN', // We don't need any cookie consent and the manager is completely hidden
  OPT_IN = 'OPT-IN', // The cookie consent must be obtained for all non-essential cookies
  OPT_OUT = 'OPT-OUT', // Inform that we use cookies with option to opt-out and limit to essential cookies only
  RESTORED = 'RESTORED' // The compliance has already been detected and the consents are set
}
